import { render, staticRenderFns } from "./teacherEvalute.vue?vue&type=template&id=1d316c7f&scoped=true"
import script from "./teacherEvalute.vue?vue&type=script&lang=js"
export * from "./teacherEvalute.vue?vue&type=script&lang=js"
import style0 from "./teacherEvalute.vue?vue&type=style&index=0&id=1d316c7f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d316c7f",
  null
  
)

export default component.exports